export default {"src":"/_next/static/media/SocialFacebook.3a939098.svg","height":28,"width":28,"blurWidth":0,"blurHeight":0};